import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'selectionRowAllowed',
    standalone: false
})
export class SelectionRowAllowedPipe implements PipeTransform {

  transform(rows: any): boolean {
    return rows.length && rows.some((row:any) => row.isMovementAllowed);
  }

}
